export default {
    createCompanyHoliday: 'สร้างวันหยุดบริษัท',
    updateCompanyHoliday: 'แก้ไขวันหยุดบริษัท',
    name: 'ชื่อ',
    date: 'วันที่',
    description: 'คำอธิบาย',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    save: 'บันทึก',
    congratulation: 'ยินดีด้วย',
    companyHolidayIsUpdated: 'วันหยุดบริษัทถูกอัปเดตแล้ว',
    companyHolidayIsCreated: 'วันหยุดบริษัทถูกสร้างแล้ว'
}
